import "babel-polyfill";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";

// Components
import "./components";
import "./views/components";

//Filters
import "./filters";

// Plugins
import "./plugins";

// Sync router with store
import { sync } from "vuex-router-sync";

// Application imports
import App from "./App";
import i18n from "@/i18n";
import router from "@/router";
import store from "@/store";
import VueProgressBar from "vue-progressbar";
import Notifications from "vue-notification";
import "axios-progress-bar/dist/nprogress.css";
//import * as VueGoogleMaps from "vue2-google-maps";
import "leaflet/dist/leaflet.css";

// Sync store with router
sync(store, router);

Vue.config.productionTip = false;

Vue.use(VueProgressBar, {
    color: "#029de5",
    failedColor: "red",
    height: "1px",
});

// Vue.use(VueGoogleMaps, {
//     load: {
//         key: "AIzaSyCtYeCL8HkqlMKJh6g6jcDvoH60-woVbDE",
//         libraries: "places",
//     },
// });

Vue.use(Notifications);
//Vue.use(Fragment.Plugin);

Vue.prototype.Progress = VueProgressBar;
Vue.config.devtools = true;
/* eslint-disable no-new */
new Vue({
    i18n,
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
